import { Component } from '@angular/core';

@Component({
  selector: 'app-mondats',
  templateUrl: './mondats.component.html',
  styleUrls: ['./mondats.component.scss']
})
export class MondatsComponent {
  onNavigateRejoindre() {
    window.open('https://thedoorman-recrute.fr/', '_blank', 'noopener,noreferrer');
  }
}
